import http from '@/utils/http'
import moment from 'moment'
import sanitizeHTML from '@/utils/quill-sanitize'

// URL and endpoint constants
const API_URL = process.env.API_BASE_URL

const getTiposDocumentoAutorizados = () => {
  const DOCUMENT_TYPES_URL = API_URL + 'tipos-documentos'
  let config = {
    method: 'get',
    url: DOCUMENT_TYPES_URL,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getTiposDocumentoGlossario = () => {
  const DOCUMENT_TYPES_URL = API_URL + 'tipos-documentos'
  let config = {
    method: 'get',
    url: DOCUMENT_TYPES_URL,
    responseType: 'json',
    credentials: true,
    params: {
      paraInclusaoEmVocabularioControlado: true
    }
  }
  return http(config)
}

const getTodosTiposDocumento = () => {
  const DOCUMENT_TYPES_URL = API_URL + 'tipos-documentos?todosTipos=true'
  let config = {
    method: 'get',
    url: DOCUMENT_TYPES_URL,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getListaDocumentos = (parameters) => {
  let config = {
    method: 'get',
    url: API_URL + 'documentos',
    params: {
      numeroDocumento: parameters.numeroDocumento,
      resumoAssunto: parameters.resumoAssunto,
      idTipoDocumento: parameters.idTipoDocumento,
      idAssunto: parameters.idAssunto,
      dataCriacaoInicio: parameters.dataCriacaoInicio !== undefined ? moment(parameters.dataCriacaoInicio).format('YYYY-MM-DD') : parameters.dataCriacaoInicio,
      dataCriacaoFim: parameters.dataCriacaoFim !== undefined ? moment(parameters.dataCriacaoFim).format('YYYY-MM-DD') : parameters.dataCriacaoFim,
      dataEnvioInicio: parameters.dataEnvioInicio !== undefined ? moment(parameters.dataEnvioInicio).format('YYYY-MM-DD') : parameters.dataEnvioInicio,
      dataEnvioFim: parameters.dataEnvioFim !== undefined ? moment(parameters.dataEnvioFim).format('YYYY-MM-DD') : parameters.dataEnvioFim,
      tipoInteressado: parameters.tipoInteressado,
      idInteressado: parameters.interessado,
      idProcedencia: parameters.idProcedencia,
      tipoResponsavelTramitacao: parameters.tipoResponsavelTramitacao,
      idResponsavelTramitacao: parameters.responsavelTramitacao,
      idServidorLotadoProcedencia: parameters.servidoresProcedencia
    },
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getListaDocumentosCaixaPostal = (parameters) => {
  let config = {
    method: 'get',
    url: API_URL + 'caixa-postal',
    params: {
      numeroDocumento: parameters.numeroDocumento && parameters.numeroDocumento.length > 0 ? parameters.numeroDocumento : undefined,
      idTipoDocumento: parameters.idTipoDocumento,
      idUnidadeAtual: parameters.idUnidadeAtual,
      dataInicio: moment(parameters.dataEnvioInicio).format('YYYY-MM-DD'),
      dataFim: moment(parameters.dataEnvioFim).format('YYYY-MM-DD')
    },
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getListaDocumentosParaJuntada = (numeroDocumento) => {
  let config = {
    method: 'get',
    url: API_URL + 'caixa-postal',
    params: {
      numeroDocumento: numeroDocumento
    },
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getListaDocumentosParaDesmembramento = (numeroDocumento) => {
  let config = {
    method: 'get',
    url: API_URL + 'caixa-postal',
    params: {
      numeroDocumento: numeroDocumento
    },
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getDocument = (idDocumento) => {
  const DOCUMENT_URL = API_URL + 'documentos/' + idDocumento
  let config = {
    method: 'get',
    url: DOCUMENT_URL,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const receberDocumento = (idDocumento) => {
  let config = {
    method: 'post',
    url: API_URL + `documentos/${idDocumento}/receber`,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const receberDocumentoReencaminhamento = (idDocumento) => {
  let config = {
    method: 'post',
    url: API_URL + `reencaminhamento/documento/${idDocumento}/receber`,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const realizarReencaminhamento = (idDocumento, idPasso, idDestino, despacho, despachoFormatado) => {
  let config = {
    method: 'post',
    url: API_URL + `reencaminhamento/documento/${idDocumento}/tramitacoes`,
    responseType: 'json',
    credentials: true,
    body: {
      idPasso: idPasso,
      idDestino: idDestino,
      despacho: despacho,
      despachoFormatado: sanitizeHTML(despachoFormatado)
    }
  }
  return http(config)
}

const getInteressadoPorId = (idTipoInteressado, idInteressado) => {
  const INTERESTED_ENTITIES_URL = API_URL + 'interessados/' + idTipoInteressado
  let config = {
    method: 'get',
    url: INTERESTED_ENTITIES_URL,
    params: {
      idInteressado: idInteressado
    },
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getResponsavelTramitacaoPorId = (idTipoResponsavelTramitacao, idResponsavelTramitacao) => {
  const INTERESTED_ENTITIES_URL = API_URL + 'responsaveis-tramitacao/' + idTipoResponsavelTramitacao
  let config = {
    method: 'get',
    url: INTERESTED_ENTITIES_URL,
    params: {
      idResponsavelTramitacao: idResponsavelTramitacao
    },
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getListaUnidadesReencaminhamento = () => {
  let config = {
    method: 'get',
    url: API_URL + 'reencaminhamento/unidades',
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getListaDocumentosReencaminhamento = (idUnidade, numeroDocumento) => {
  let config = {
    method: 'get',
    url: API_URL + `reencaminhamento/unidades/${idUnidade}/caixa-postal`,
    params: {
      numeroDocumento: numeroDocumento && numeroDocumento.length > 0 ? numeroDocumento : undefined
    },
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getListaUnidadesProcedenciaCaixaPostal = () => {
  const URL_UNIDADES_PROCEDENCIA = API_URL + 'procedencias/caixa-postal/UNIDADE'
  let config = {
    method: 'get',
    url: URL_UNIDADES_PROCEDENCIA,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getListaUnidadesProcedenciaRelatorios = (relatorio) => {
  let config = {
    method: 'get',
    url: API_URL + `relatorios/${relatorio}/unidades`,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getUnidadeProcedenciaPorId = (idProcedencia) => {
  const URL_UNIDADES_PROCEDENCIA = API_URL + 'procedencias/UNIDADE'
  let config = {
    method: 'get',
    url: URL_UNIDADES_PROCEDENCIA,
    params: {
      idProcedencia: idProcedencia
    },
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getProcessingsList = (idDocumento) => {
  const PROCESSINGS_LIST_URL = API_URL + 'documentos/' + idDocumento + '/tramitacoes'
  let config = {
    method: 'get',
    url: PROCESSINGS_LIST_URL,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getListaArquivos = (idDocumento) => {
  const LISTA_ARQUIVOS_URL = API_URL + 'documentos/' + idDocumento + '/anexos'
  let config = {
    method: 'get',
    url: LISTA_ARQUIVOS_URL,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getListaPecas = (idDocumento) => {
  let config = {
    method: 'get',
    url: API_URL + 'documentos/' + idDocumento + '/pecas',
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getListaVinculosDocumento = (idDocumento) => {
  let config = {
    method: 'get',
    url: API_URL + 'documentos/' + idDocumento + '/agregados',
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getPassosFluxoPossiveisList = (idDocumento) => {
  let config = {
    method: 'get',
    url: API_URL + 'documentos/' + idDocumento + '/fluxos',
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getPassosFluxoPossiveisReencaminhamentoList = (idDocumento) => {
  let config = {
    method: 'get',
    url: API_URL + 'reencaminhamento/documento/' + idDocumento + '/fluxos',
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getDestinosPassoFluxoList = (idDocumento, fluxoId) => {
  let config = {
    method: 'get',
    url: API_URL + 'documentos/' + idDocumento + '/fluxos/' + fluxoId + '/destinos',
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getValidacaoFluxo = (idDocumento, fluxoId) => {
  let config = {
    method: 'get',
    url: API_URL + 'documentos/' + idDocumento + '/fluxos/' + fluxoId + '/consistencia',
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getUltimaTramitacao = (idDocumento) => {
  let config = {
    method: 'get',
    url: API_URL + 'documentos/' + idDocumento + '/ultima-tramitacao',
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getMotivosRestricoesArquivo = () => {
  let config = {
    method: 'get',
    url: API_URL + 'propriedades/hipoteses-legais',
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getEmailInteressado = (idTipoInteressado, idInteressado) => {
  let config = {
    method: 'get',
    url: API_URL + `interessados/${idTipoInteressado}/${idInteressado}/email`,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getDespachoSalvo = (idDocumento) => {
  let config = {
    method: 'get',
    url: API_URL + `documentos/${idDocumento}/tramitacoes/despacho`,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const salvarDespacho = (idDocumento, despacho, despachoFormatado) => {
  let config = {
    method: 'patch',
    url: API_URL + `documentos/${idDocumento}/tramitacoes`,
    responseType: 'json',
    credentials: true,
    body: {
      despacho: despacho,
      despachoFormatado: sanitizeHTML(despachoFormatado)
    }
  }
  return http(config)
}

const salvarDespachoPreparatorio = (idDocumento, despachoPreparatorio) => {
  let config = {
    method: 'patch',
    url: API_URL + `documentos/${idDocumento}/tramitacoes`,
    responseType: 'json',
    credentials: true,
    body: {
      despachoPreparatorio: despachoPreparatorio
    }
  }
  return http(config)
}

const enviarTramitacao = (idDocumento, fluxo, destino, despacho, tipoDespacho, nivelAcesso, hipoteseLegal, despachoPreparatorio, despachoFormatado) => {
  let config = {
    method: 'post',
    url: API_URL + 'documentos/' + idDocumento + '/tramitacoes',
    responseType: 'json',
    credentials: true,
    body: {
      idPasso: fluxo,
      idDestino: destino,
      despacho: despacho,
      despachoFormatado: sanitizeHTML(despachoFormatado),
      tipoDespacho: tipoDespacho,
      nivelAcesso: nivelAcesso,
      idHipoteseLegal: hipoteseLegal,
      despachoPreparatorio: despachoPreparatorio
    }
  }
  return http(config)
}

const juntarDocumentos = (tipoJuntada, documento, juntador) => {
  let config = {
    method: 'post',
    url: API_URL + 'documentos/' + juntador.idDocumento + '/agregados',
    responseType: 'json',
    credentials: true,
    body: {
      idDocumento: String(documento.idDocumento),
      tipoAgregacao: tipoJuntada.nome
    }
  }
  return http(config)
}

const getArquivo = (idDocumento, idArquivo) => {
  let config = {
    method: 'get',
    url: API_URL + `documentos/${idDocumento}/anexos/${idArquivo}`,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getArquivoBinario = (idDocumento, idArquivo) => {
  let config = {
    method: 'get',
    url: API_URL + `documentos/${idDocumento}/anexos/${idArquivo}/binario`,
    responseType: 'arraybuffer',
    credentials: true
  }
  return http(config)
}

const excluirArquivo = (idDocumento, idArquivo) => {
  let config = {
    method: 'delete',
    url: API_URL + 'documentos/' + idDocumento + '/anexos/' + idArquivo,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const cancelarPeca = (idDocumento, idPeca, situacaoVinculo, justificativaCancelamento, idDocumentoPecaDesmembramento) => {
  let config = {
    method: 'patch',
    url: API_URL + `documentos/${idDocumento}/pecas/${idPeca}/cancelar`,
    responseType: 'json',
    credentials: true,
    body: {
      situacaoVinculo: situacaoVinculo,
      justificativaCancelamento: justificativaCancelamento,
      idDocumentoPecaDesmembramento: idDocumentoPecaDesmembramento
    }
  }
  return http(config)
}

const enviarArquivo = (idDocumento, body) => {
  let config = {
    method: 'post',
    url: API_URL + 'documentos/' + idDocumento + '/anexos',
    responseType: 'json',
    emulateJSON: true,
    headers: {'Content-Type': 'multipart/form-data'},
    credentials: true,
    body: body
  }
  return http(config)
}

const salvarAlteracoesArquivo = (idDocumento, idAcessoAnexo, idAnexo, arquivo) => {
  let config = {
    method: 'patch',
    url: API_URL + `documentos/${idDocumento}/pecas/${idAcessoAnexo}`,
    responseType: 'json',
    credentials: true,
    body: {
      idAnexo: idAnexo,
      descricao: arquivo.descricao,
      tipoCopia: arquivo.tipoCopia,
      nivelAcesso: arquivo.nivelAcesso,
      idHipoteseLegal: arquivo.idHipoteseLegal,
      justificativaAlteracao: arquivo.justificativaAlteracao
    }
  }
  return http(config)
}

const solicitaConsolidacao = (parameters) => {
  let config = {
    method: 'post',
    url: API_URL + `consolidacao/${parameters.idDocumento}/${parameters.tipo}`,
    responseType: 'json',
    credentials: true,
    body: parameters.idsPecas
  }
  return http(config)
}

const getPDFCapa = (parameters) => {
  let config = {
    method: 'get',
    url: API_URL + 'documentos/' + parameters.idDocumento + '/capa',
    responseType: 'arraybuffer',
    credentials: true
  }
  return http(config)
}

const getPDFComprovanteProtocolizacao = (parameters) => {
  let config = {
    method: 'get',
    url: API_URL + 'documentos/' + parameters.idDocumento + '/comprovante',
    responseType: 'arraybuffer',
    credentials: true
  }
  return http(config)
}

const enviarComprovanteProtocolizacaoPorEmail = (parameters) => {
  let config = {
    method: 'get',
    url: API_URL + 'documentos/' + parameters.idDocumento + '/comprovante/email',
    params: {
      destinatario: parameters.destinatario
    },
    credentials: true
  }
  return http(config)
}

const desapensarDocumentos = (idDocumentoPai, idDocumentoFilho) => {
  let config = {
    method: 'delete',
    url: API_URL + `documentos/${idDocumentoPai}/agregados/${idDocumentoFilho}`,
    credentials: true
  }
  return http(config)
}

const getListaUnidadesProcedenciaConsulta = () => {
  const UNIDADES_AUTUACAO_URL = API_URL + 'procedencias/UNIDADE?somenteAtivas=false'
  let config = {
    method: 'get',
    url: UNIDADES_AUTUACAO_URL,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getListaServidoresProcedencia = () => {
  const SERVIDORES_PROCEDENCIA_URL = API_URL + 'procedencias/usuarios-lotados'
  let config = {
    method: 'get',
    url: SERVIDORES_PROCEDENCIA_URL,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const salvarTags = (idDocumento, tags) => {
  let config = {
    method: 'post',
    url: API_URL + 'documentos/' + idDocumento + '/tags',
    responseType: 'json',
    credentials: true,
    body: {
      stringTags: tags
    }
  }
  return http(config)
}

const favoritarDocumento = (idDocumento) => {
  let config = {
    method: 'post',
    url: API_URL + `documentos-favoritos/${idDocumento}`,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const desfavoritarDocumento = (idDocumento) => {
  let config = {
    method: 'delete',
    url: API_URL + `documentos-favoritos/${idDocumento}`,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const buscarDocumentosFavoritos = (payload) => {
  let config = {
    method: 'get',
    url: API_URL + `documentos-favoritos`,
    responseType: 'json',
    credentials: true,
    params: {
      dataInicioUltimaAlteracao: payload.dataInicioUltimaAlteracao,
      dataFimUltimaAlteracao: payload.dataFimUltimaAlteracao,
      resumoDocumento: payload.resumoDocumento,
      idTipoDocumento: payload.idTipoDocumento
    }
  }
  return http(config)
}

const alternarAcompanhamentoDeDocumentoFavorito = (idDocumento, acompanharPorEmail) => {
  let config = {
    method: 'patch',
    url: API_URL + `documentos-favoritos/${idDocumento}`,
    responseType: 'json',
    credentials: true,
    body: {
      acompanhadoPorEmail: acompanharPorEmail
    }
  }
  return http(config)
}

const alterarMarcadoresDeDocumentosFavoritos = (idDocumento, tags) => {
  let config = {
    method: 'patch',
    url: API_URL + `documentos-favoritos/${idDocumento}/tags`,
    responseType: 'json',
    credentials: true,
    body: tags
  }
  return http(config)
}

const buscarArquivosAssinados = () => {
  let config = {
    method: 'get',
    url: API_URL + `arquivos-assinados/`,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const buscarArquivosAssinadosVinculados = (vinculados, usuarioAssinante, dataAssinaturaInicio, dataAssinaturaFim, arquivosAssinadosUsuario) => {
  let config = {
    method: 'get',
    url: API_URL + `arquivos-assinados/`,
    responseType: 'json',
    credentials: true,
    params: {
      vinculados: vinculados,
      usuarioAssinante: usuarioAssinante,
      dataAssinaturaInicio: dataAssinaturaInicio,
      dataAssinaturaFim: dataAssinaturaFim,
      arquivosAssinadosUsuario: arquivosAssinadosUsuario
    }
  }
  return http(config)
}

const buscarArquivoAssinado = (idArquivoAssinado, tipoArquivo) => {
  let config = {
    method: 'get',
    url: API_URL + `arquivos-assinados/${idArquivoAssinado}`,
    responseType: 'arraybuffer',
    credentials: true,
    params: {
      tipoArquivo: tipoArquivo
    }
  }
  return http(config)
}

const buscarTiposAssinatura = () => {
  let config = {
    method: 'get',
    url: API_URL + `arquivos-assinados/tipos-assinatura`,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const excluirArquivoAssinado = (idArquivoAssinado) => {
  let config = {
    method: 'delete',
    url: API_URL + `arquivos-assinados/${idArquivoAssinado}`,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const inserirArquivoAssinado = (body, idTipoAssinatura, tipoAssinatura, matrSiape) => {
  let config = {
    method: 'post',
    url: API_URL + 'arquivos-assinados/',
    responseType: 'json',
    emulateJSON: true,
    headers: {'Content-Type': 'multipart/form-data'},
    credentials: true,
    body: body,
    params: {
      idTipoAssinatura: idTipoAssinatura,
      tipoAssinatura: tipoAssinatura,
      matrSiape: matrSiape
    }
  }
  return http(config)
}

const assinarPecaExistente = (idAcessoAnexo, idDocumento, idTipoAssinatura, tipoAssinatura, matrSiape) => {
  let config = {
    method: 'post',
    url: API_URL + `arquivos-assinados/assinar-peca-documento`,
    responseType: 'json',
    credentials: true,
    body: {
      idPeca: idAcessoAnexo,
      idDocumento: idDocumento,
      idTipoAssinatura: idTipoAssinatura,
      tipoAssinatura: tipoAssinatura,
      matrSiape: matrSiape
    }
  }
  return http(config)
}

const enviarArquivoAssinado = (idArquivoAssinado, idDocumento, body) => {
  let config = {
    method: 'post',
    url: API_URL + `arquivos-assinados/${idArquivoAssinado}/vincular-documento/${idDocumento}`,
    responseType: 'json',
    emulateJSON: true,
    credentials: true,
    body: body
  }
  return http(config)
}

const alterarSequencialPeca = (idDocumento, idAcessoAnexo, novoSequencial) => {
  let config = {
    method: 'patch',
    url: API_URL + `documentos/${idDocumento}/pecas/${idAcessoAnexo}`,
    responseType: 'json',
    credentials: true,
    body: {
      sequencial: novoSequencial
    }
  }
  return http(config)
}

const buscarConsolidacoes = () => {
  let config = {
    method: 'get',
    url: API_URL + `consolidacao`,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const buscarConsolidacaoPorUUID = (listTrabalhos) => {
  let config = {
    method: 'post',
    url: API_URL + `consolidacao`,
    responseType: 'json',
    credentials: true,
    body: listTrabalhos
  }
  return http(config)
}

export default {
  getTiposDocumentoAutorizados,
  getTiposDocumentoGlossario,
  getTodosTiposDocumento,
  getListaDocumentos,
  getListaDocumentosCaixaPostal,
  getListaDocumentosParaJuntada,
  getListaDocumentosParaDesmembramento,
  getDocument,
  getInteressadoPorId,
  getResponsavelTramitacaoPorId,
  getListaUnidadesReencaminhamento,
  getListaDocumentosReencaminhamento,
  getListaUnidadesProcedenciaCaixaPostal,
  getListaUnidadesProcedenciaRelatorios,
  getUnidadeProcedenciaPorId,
  getProcessingsList,
  getListaArquivos,
  getListaPecas,
  getListaVinculosDocumento,
  getPassosFluxoPossiveisList,
  getPassosFluxoPossiveisReencaminhamentoList,
  getDestinosPassoFluxoList,
  getValidacaoFluxo,
  getUltimaTramitacao,
  getMotivosRestricoesArquivo,
  getEmailInteressado,
  getArquivo,
  getArquivoBinario,
  solicitaConsolidacao,
  getPDFCapa,
  getPDFComprovanteProtocolizacao,
  getDespachoSalvo,
  enviarComprovanteProtocolizacaoPorEmail,
  receberDocumento,
  receberDocumentoReencaminhamento,
  realizarReencaminhamento,
  salvarDespacho,
  salvarDespachoPreparatorio,
  enviarTramitacao,
  juntarDocumentos,
  excluirArquivo,
  cancelarPeca,
  enviarArquivo,
  salvarAlteracoesArquivo,
  desapensarDocumentos,
  getListaUnidadesProcedenciaConsulta,
  getListaServidoresProcedencia,
  salvarTags,
  favoritarDocumento,
  desfavoritarDocumento,
  buscarDocumentosFavoritos,
  alternarAcompanhamentoDeDocumentoFavorito,
  alterarMarcadoresDeDocumentosFavoritos,
  buscarArquivosAssinados,
  buscarArquivosAssinadosVinculados,
  buscarArquivoAssinado,
  buscarTiposAssinatura,
  excluirArquivoAssinado,
  inserirArquivoAssinado,
  assinarPecaExistente,
  enviarArquivoAssinado,
  alterarSequencialPeca,
  buscarConsolidacoes,
  buscarConsolidacaoPorUUID
}
